export default __webpack_public_path__ + "static/media/blazedsuperfly.28b9294d.jpg";